// src/services/azureElGatoMuertoBlobService.js
// Blob-Upload/Delete für die El-Gato-Muerto-Galerie unter /main-website.
// Nutzt den bestehenden Container `project-images` mit dem Pfad-Prefix
// `el-gato-muerto/` (Entscheid: kein eigener Container, siehe ADR 0004).

const AZURE_BLOB_CONFIG = {
  storageAccount: "mfprojects",
  containerName: "project-images",
  pathPrefix: "el-gato-muerto",
  sasToken:
    "sv=2024-11-04&ss=b&srt=co&sp=rwdlaciytfx&se=2035-10-02T19:07:10Z&st=2025-10-02T10:52:10Z&spr=https&sig=A8jWH2s8LkqmqiQjwjR8bL4sLjDKgKlE1HkDCZSlsYk%3D",
};

const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
const MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB laut Akzeptanzkriterium

const sanitizeFileName = (name) => {
  // Sonderzeichen ersetzen, damit der Blob-Name URL-sicher bleibt.
  return name
    .normalize("NFKD")
    .replace(/[^a-zA-Z0-9._-]/g, "_")
    .replace(/_+/g, "_");
};

const buildBlobUrl = (blobName) =>
  `https://${AZURE_BLOB_CONFIG.storageAccount}.blob.core.windows.net/${AZURE_BLOB_CONFIG.containerName}/${blobName}`;

export const validateElGatoImageFile = (file) => {
  if (!file) throw new Error("Keine Datei ausgewählt");
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error(
      `Ungültiges Format: ${file.type}. Erlaubt sind JPG, PNG und WebP.`,
    );
  }
  if (file.size > MAX_SIZE_BYTES) {
    throw new Error(
      `Datei zu gross: ${(file.size / 1024 / 1024).toFixed(1)} MB. Maximal 10 MB pro Bild.`,
    );
  }
};

export const uploadElGatoMuertoImage = async (file) => {
  validateElGatoImageFile(file);

  const uuid = `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
  const safeName = sanitizeFileName(file.name);
  const blobName = `${AZURE_BLOB_CONFIG.pathPrefix}/${uuid}_${safeName}`;
  const url = `${buildBlobUrl(blobName)}?${AZURE_BLOB_CONFIG.sasToken}`;

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "x-ms-blob-type": "BlockBlob",
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!response.ok) {
    const errorText = await response.text();
    if (response.status === 404) {
      throw new Error(
        `Container '${AZURE_BLOB_CONFIG.containerName}' nicht gefunden. Bitte im Azure Portal anlegen.`,
      );
    }
    if (response.status === 403) {
      throw new Error("Zugriff verweigert. SAS Token ungültig oder abgelaufen.");
    }
    throw new Error(`Upload fehlgeschlagen (${response.status}): ${errorText}`);
  }

  return {
    blobName,
    url: buildBlobUrl(blobName),
    altText: "",
  };
};

export const deleteElGatoMuertoImage = async (blobName) => {
  if (!blobName) return;
  const url = `${buildBlobUrl(blobName)}?${AZURE_BLOB_CONFIG.sasToken}`;
  const response = await fetch(url, { method: "DELETE" });
  if (!response.ok && response.status !== 404) {
    const errorText = await response.text();
    throw new Error(
      `Löschen fehlgeschlagen (${response.status}): ${errorText}`,
    );
  }
};
